// Confetti effect component
export function createConfetti() {
    const colors = ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff', '#ff8800', '#8800ff'];
    const confettiCount = 100;
    const animations = ['confetti-fall-1', 'confetti-fall-2', 'confetti-fall-3', 'confetti-fall-4'];
    const container = document.createElement('div');
    container.className = 'confetti-container';
    container.setAttribute('aria-hidden', 'true');

    for (let i = 0; i < confettiCount; i++) {
        const confetti = document.createElement('div');
        confetti.className = 'confetti';

        // Random color
        confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];

        // Random horizontal position
        confetti.style.left = Math.random() * 100 + '%';

        // Random animation from the 4 variations
        const randomAnimation = animations[Math.floor(Math.random() * animations.length)];
        confetti.style.animationName = randomAnimation;

        // Random animation delay
        confetti.style.animationDelay = Math.random() * 2 + 's';

        // Random animation duration (slightly varied for more organic feel)
        confetti.style.animationDuration = (Math.random() * 2 + 4) + 's';

        // Use linear timing for smooth swirls
        confetti.style.animationTimingFunction = 'ease-out';

        // Random size
        const size = Math.random() * 6 + 4;
        confetti.style.width = size + 'px';
        confetti.style.height = size + 'px';

        // Random shape - some rectangular for more variety
        if (Math.random() > 0.5) {
            confetti.style.height = (size * 1.5) + 'px';
        }

        container.appendChild(confetti);
    }

    document.body.appendChild(container);

    // Remove confetti after animation completes
    setTimeout(() => {
        container.remove();
    }, 8000);
}
